<template>
  <div>
    <form @submit="submitForm($event)" v-if="!isLoading">
      <div class="form-group">
        <label for="product"
          >Item Name
          <span class="invalid" v-if="data.name == ''">
            - Field is required
          </span>
        </label>
        <input
          name="product"
          type="text"
          v-model.trim="data.name"
          placeholder="Enter item name"
          class="form-control"
        />
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="location"
              >Location
              <span class="invalid" v-if="data.locationId == ''">
                - Field is required
              </span>
            </label>
            <v-select
              name="location"
              :options="locations"
              v-model="data.locationId"
              id="location"
              placeholder="Choose a location"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="category"
              >Category
              <span class="invalid" v-if="data.categoryId == ''">
                - Field is required
              </span>
            </label>
            <v-select
              name="category"
              :options="categories"
              v-model="data.categoryId"
              id="category"
              placeholder="Choose a category"
            >
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="eventName">Image</label>
        <div class="row">
          <div class="col-9">
            <input
              type="text"
              name="featuredImage"
              v-model="data.image"
              class="form-control"
              disabled
            />
          </div>
          <div class="col-3">
            <ActionButton
              :theme="{ primary, secondary, danger, event }"
              @customEvent="showMediaGallery = true"
              label="Media Gallery"
              style="width: auto; margin-top: 0; margin-left: auto;"
            />
          </div>
        </div>
      </div>
      <div class="form-group" v-if="data.quantity > -1">
        <label for="quantity"
          >Quantity
          <span class="invalid" v-if="data.quantity == ''">
            - Field is required
          </span>
        </label>
        <input
          type="number"
          class="form-control"
          v-model="data.quantity"
          placeholder="Enter Quantity"
        />
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="description"
              >Description
              <span class="invalid" v-if="data.description == ''">
                - Field is required
              </span>
            </label>
            <wysiwyg
              placeholder="Enter description"
              class="form-control h-auto"
              name="description"
              v-model="data.description"
            />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="Inclusions">Inclusions</label>
        <div class="row mt-10">
          <div
            class="col-md-6"
            :key="inclusion.value"
            v-for="inclusion in inclusions"
          >
            <Checkbox
              :value="data.inclusions.includes(inclusion.value)"
              :label="inclusion.label"
              @toggled="handleInclusionToggle(inclusion)"
            />
          </div>
        </div>
      </div>
      <div class="row submit-row">
        <div class="col d-flex">
          <div
            :class="`switch ${data.status < 2 ? '' : 'active'}`"
            @click="data.status === 1 ? (data.status = 2) : (data.status = 1)"
          >
            <div class="indicator"></div>
          </div>
          <span
            @click="data.status === 1 ? (data.status = 2) : (data.status = 1)"
            >{{ data.status === 1 ? "Inactive" : "Active" }}</span
          >
        </div>
        <div class="col d-flex">
          <div
            :class="`switch ${data.quantity > -1 ? 'active' : ''}`"
            @click="
              data.quantity < 0 ? (data.quantity = 1) : (data.quantity = -1)
            "
          >
            <div class="indicator"></div>
          </div>
          <span
            @click="
              data.quantity < 0 ? (data.quantity = 1) : (data.quantity = -1)
            "
            >{{
              data.quantity > -1 ? "Validate booking" : "No Validation"
            }}</span
          >
        </div>
        <div class="col">
          <ActionButton
            type="submit"
            label="Save"
            :theme="{ primary, secondary, event, danger }"
            style="width: auto; margin-left: auto; margin-top: 0;"
            :disabled="loader"
          />
        </div>
      </div>
    </form>
    <Spinner style="display: block;" :theme="primary" v-else></Spinner>
    <MediaGalleryModal
      v-if="showMediaGallery"
      @response="handleMediaGalleryImage"
      @close="showMediaGallery = false"
    />
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { socketSender } from "@/helpers/socket";
import ActionButton from "@/components/ActionButton";
import Checkbox from "@/components/Checkbox";
import MediaGalleryModal from "@/components/media-gallery/MediaGalleryModal";
import Spinner from "@/components/Spinner";

export default {
  name: "AddProduct",
  components: {
    ActionButton,
    MediaGalleryModal,
    Checkbox,
    Spinner
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    },
    link: {
      type: String,
      default: null
    }
  },
  data: () => ({
    data: {
      name: null,
      image: null,
      description: null,
      quantity: null,
      categoryId: null,
      locationId: null,
      status: 1,
      inclusions: []
    },

    categories: [],
    locations: [],
    inclusions: [],

    productId: null,
    showMediaGallery: false,
    isLoading: true,
    loader: false
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.paginated("locations");
      this.paginated("categories");
      this.paginated("inclusions", "status=2");
      this.editSelectedProduct();
    },
    paginated(collection, action = "", page = 1) {
      axios
        .get(`/${collection}?page[number]=${page}&page[size]=10&${action}`)
        .then(response => {
          var { data, meta } = response.data;
          data = data.map(product => ({
            label: product.name,
            value: product.id
          }));
          this[collection] = [...this[collection], ...data];
          if (meta.hasNextPage) {
            this.paginated(collection, action, page + 1);
          }
        });
    },
    handleInclusionToggle(inclusion) {
      var { inclusions } = this.data;
      if (inclusions.includes(inclusion.value)) {
        inclusions = inclusions.filter(i => i != inclusion.value);
      } else {
        inclusions.push(inclusion.value);
      }
      this.data.inclusions = inclusions;
    },
    handleMediaGalleryImage(obj) {
      this.data.image = obj.original;
    },
    async editSelectedProduct() {
      try {
        const record = this.singleRecord;
        if (record) {
          const category = await axios
            .get(`categories/${record.categoryId}`)
            .then(res => res.data.data);
          const location = await axios
            .get(`locations/${record.locationId}`)
            .then(res => res.data.data);
          this.data = {
            name: record.name,
            image: record.image,
            description: record.description,
            quantity: record.quantity,
            categoryId: { label: category.name, value: category.id },
            locationId: { label: location.name, value: location.id },
            status: record.status,
            inclusions:
              record && record.Inclusions
                ? record.Inclusions.map(inclusion => inclusion.id)
                : []
          };
          this.productId = record.id;
        }
        this.isLoading = false;
      } catch (error) {
        this.$emit("close");
      }
    },
    async submitForm(event) {
      this.loader = true;
      event.preventDefault();
      var form = JSON.parse(JSON.stringify(this.data));
      if (this.validate(form)) {
        form.categoryId = this.data.categoryId.value;
        form.locationId = this.data.locationId.value;
        if (this.productId) {
          await axios.patch("/products/" + this.productId, form);
        } else {
          await socketSender(
            "updateLog",
            `${this.$store.getters.getFullUser} added a new Inventory named ${form.name}`
          );
          await axios.post("/products", form);
        }

        this.$store.dispatch("FETCH_COLLECTION_PER_PAGE", this.link);
        this.$toastr.success("Your changes are saved", "Success");
        this.$emit("close");
        this.loader = false;
      } else {
        this.loader = false;
        return;
      }
    },
    validate(form) {
      const { name, description, categoryId, locationId, quantity } = form;
      const validate =
        name &&
        description &&
        categoryId &&
        locationId &&
        (quantity == -1 || quantity > 0);
      if (validate) {
        return true;
      } else {
        if (!name) {
          this.data.name = "";
        }
        if (!description) {
          this.data.description = "";
        }
        if (!categoryId) {
          this.data.categoryId = "";
        }
        if (!locationId) {
          this.data.locationId = "";
        }
        if (quantity == 0 || quantity == null) {
          this.data.quantity = "";
        }
        return false;
      }
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    user() {
      return this.$store.getters.getFullUser;
    }
  }
};
</script>
